<template lang="pug">

    section.section.swatch-gray.search-elements
        div.container
            div.row
                div.col-md-12
                    header.text-left.element-tall-top.element-medium-bottom.os-animation
                        div.row
                            div.col-md-4
                                h1.bigger.hairline.bordered.bordered-small Наши услуги

                            div.col-md-8
                                input.form-control(
                                    type="text"
                                    placeholder="Начните печатать для поиска..."
                                    v-model="searchString"
                                )
                    div.row
                        div.col-md-4(
                            v-for="section in sections"
                            v-if="isSectionHasItems(section['ID'])"
                        )
                            ul.features-list.element-no-top.element-no-bottom.features-white
                                li.element-no-top.element-short-bottom
                                    div.features-list-icon
                                        i.fa(
                                            v-bind:class="section['CODE']"
                                        )

                                    h3 {{ section['NAME'] }}
                                    ul.list-unstyled
                                        li(
                                            v-for="service in getSectionItems(section['ID'])"
                                        )
                                            a(
                                                v-bind:href="service['PROPERTY_URL_VALUE']"
                                                v-bind:title="service['NAME']"
                                            ) {{ service['NAME'] }}
</template>

<script>

    import _ from 'lodash';

    export default {
        props: [
            'dataSections',
            'dataServices'
        ],
        data() {
            return {
                searchString: '',
                sections: {},
                services: {}
            };
        },
        mounted () {
            this.sections = JSON.parse(this.dataSections);
            this.services = JSON.parse(this.dataServices);
        },
        methods: {
            isSectionHasItems(sectionId){
                return _.size(this.getSectionItems(sectionId)) > 0;
            },
            getSectionItems(sectionId){
                let result = {};

                _.each(this.services, (service) => {
                    if(parseInt(service['IBLOCK_SECTION_ID']) === parseInt(sectionId)){
                        if(!this.searchString || (
                            service['PROPERTY_KEYWORD_VALUE'] && service['PROPERTY_KEYWORD_VALUE'].toLowerCase().indexOf(this.searchString.toLowerCase()) > -1
                        )) {
                            result[service['ID']] = service;
                        }
                    }
                });

                return _.sortBy(result, [function(o) { return parseInt(o.SORT); }]);
            }
        }
    };
</script>

<style lang="stylus">
    .search-elements
        header
            margin-bottom 24px !important

            input
                margin-top 14px

        .row.margin-bottom-30
            margin 0 0 30px 0

</style>